import React, { useState, useEffect } from 'react';
import ItemApi from '../api/ItemApi';

const ItemInventory = ({ itemId = null, type=null }) => {
    const nonce = devsAccountingApi.nonce;
    const [item, setItem] = useState({});
    const [loading, setLoading] = useState(false);
    const [formState, setFormState] = useState({
        in_out_qty: '',
        remarks: '',
        nonce: nonce,
    });
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [totalQuantity, setTotalQuantity] = useState(0);

    useEffect(() => {
        if (itemId) {
            getItem(itemId, type);
        }
    }, [itemId]);

    const getItem = async (itemId, type) => {
        const res = await ItemApi.show(itemId, {type});
        if (res) {
            setItem(res);
            calculateTotalQuantity(res.inventories);
        }
    };

    const calculateTotalQuantity = (inventories) => {
        const total = inventories?.reduce((sum, inv) => sum + parseFloat(inv.in_out_qty || 0), 0);
        setTotalQuantity(total);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState({
            ...formState,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(null);

        const inOutQty = parseFloat(formState.in_out_qty);
        const currentQty = totalQuantity;

        if (inOutQty < 0 && currentQty + inOutQty < 0) {
            setError('Quantity cannot go below zero. Update unsuccessful.');
            setLoading(false);
            return;
        }

        const data = {
            id: itemId,
            type:type,
            ...formState,
        };

        const res = await ItemApi.inventory(data);
        if (res.errors) {
            const errorMessage = res.errors?.in_out_qty || 'An error occurred.';
            setError(errorMessage);
            setLoading(false);
        }  else {
            getItem(itemId, type);
            setFormState({
                in_out_qty: '',
                remarks: '',
                nonce: nonce,
            });
            setSuccess('Inventory updated successfully!');
        }
    };

    return (
        <div>
            {success && <div className="print:hidden bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
                    <p className="font-bold">{success}</p>
                </div>}
            <div className="flex flex-col">
                <div className="overflow-x-auto shadow-md sm:rounded-lg">
                    <div className="inline-block min-w-full align-middle">
                        <div className="overflow-hidden">
                            <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                                <thead className="bg-gray-100 dark:bg-gray-700">
                                    <tr>
                                        <th className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                            Item Name
                                        </th>
                                        <th className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                            {item.name}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                            Current Quantity
                                        </th>
                                        <th className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                            {totalQuantity}
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="flex justify-between w-full items-center gap-4 px-6 py-4">
                        <div className="space-y-2  w-full">
                        <label className="text-gray-700 dark:text-gray-200" htmlFor="in_out_qty">Qty add/subtract</label>
                        <input
                            id="in_out_qty"
                            type="number"
                            className="block w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                            name="in_out_qty"
                            value={formState.in_out_qty}
                            onChange={handleChange}
                            disabled={totalQuantity <= 0 && formState.in_out_qty < 0}  
                        />

                        </div>
                        <div className="space-y-2 w-full">
                        <label className="text-gray-700 dark:text-gray-200" htmlFor="remarks">Comment</label>
                        <input
                            id="remarks"
                            type="text"
                            className="block w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                            name="remarks"
                            value={formState.remarks}
                            onChange={handleChange}
                        />
                        </div>
                        <div className="mt-6">
                        <button type="submit" className="px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600">
                            {loading ? 'Submitting...' : 'Submit'}
                        </button>
                        </div>
                        </div>
                        {error && <div className="text-red-500 mb-3 text-xs ps-6">{error}</div>}
                    </form>
                </div>
            </div>
            <div className="flex flex-col mt-3">
                <div className="overflow-x-auto shadow-md sm:rounded-lg">
                    <div className="inline-block min-w-full align-middle">
                        <div className="overflow-hidden">
                            <div>Invoice Inventory</div>
                            <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                                <thead className="bg-gray-100 dark:bg-gray-700">
                                    <tr>
                                        {/* <th className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                            Inventory Data Tracking
                                        </th> */}
                                        <th className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                            User
                                        </th>
                                        <th className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                            In/Out Qty
                                        </th>
                                        <th className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                            Remarks
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                                    {item?.inventories?.map((inventory) => (
                                        <tr key={inventory.id} className="hover:bg-gray-100 dark:hover:bg-gray-700">
                                            {/* <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                Current Quantity
                                            </td> */}
                                            <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {item.name}
                                            </td>
                                            <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {inventory.in_out_qty}
                                            </td>
                                            <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {inventory.remarks}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemInventory;
